const doc = [({"ko":({"adminConstantBankDepositType":({"checkingAccount":"당좌 예금", "ordinaryDeposit":"보통예금"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;